import { createApp } from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router).use(Vant).mount('#app')

import('./assets/font/iconfont-common.css')
import('./assets/font/iconfont-stype-icon.css')
